import { useEffect } from "react";

/**
 * A step with text fields above the pinned bar keeps the bar above the phone
 * keyboard while it is mounted (lib/keyboardViewport.ts). The watcher is its
 * own chunk, imported on the first mount: the entry carries only this call.
 * Where there is no visual viewport, or the chunk cannot load, nothing
 * changes: the step works as before.
 */
export function useKeyboardViewport(): void {
  useEffect(() => {
    if (typeof window === "undefined" || !window.visualViewport) return;
    let stop: (() => void) | null = null;
    let gone = false;
    import("./keyboardViewport")
      .then(({ watchKeyboardViewport }) => {
        if (!gone) stop = watchKeyboardViewport(window);
      })
      .catch(() => {});
    return () => {
      gone = true;
      stop?.();
    };
  }, []);
}
